import {WinPresentationController} from "../WinPresentationController";
import {WalkOfShame} from "../../WalkOfShame";
import {WalkOfShameSymbolState} from "../../symbol/WalkOfShameSymbolConfig";

export class ScattersNoWinController extends WinPresentationController {
    constructor() {
        super("ScattersNoWinController", false);
    }

    protected createWinAnimation(): Promise<void> {
        WalkOfShame.model.parsedGameData.scatterPositions.forEach((pos: number, reelId: number) => {
            if (pos > -1) {
                WalkOfShame.reels[reelId].getSymbol(pos).getStateAnimation(WalkOfShameSymbolState.NO_WIN);
            }
        });

        if (WalkOfShame.stickyS2.visible) {
            const animName: string = (WalkOfShame.model.parsedGameData.nextMode.indexOf("RESPIN") > -1 ? "noWinRespin" : "noWin");

            WalkOfShame.stickyS2.playS2Animation(animName, false);
        } else if (WalkOfShame.model.parsedGameData.s2SymId > -1) {
            WalkOfShame.reels[0].getSymbol((WalkOfShame.model.parsedGameData.s2SymId + 1)).getStateAnimation(WalkOfShameSymbolState.NO_WIN);
        }

        return Promise.resolve(undefined);
    }

    protected hasWin(): boolean {
        return WalkOfShame.model.parsedGameData.betWins.length > 0 && !WalkOfShame.model.parsedGameData.freespinTriggeredThisSpin;
    }
}